module.exports = __webpack_public_path__ + "img/ecs_main_logo.c4f79b89.jpg";